import type { AppFlowsContainer } from '#flows.js';
import type { FirestoreContainer } from './FirestoreContainer.js';

import { createContainer } from '@elara/core/di';

import { createClientNotificationModel } from '#models/NotificationModel.js';

export function createNotificationsContainer(flows: AppFlowsContainer, firestore: FirestoreContainer) {
  const $notifications = createContainer('notifications').providedLazy('ClientNotification', () =>
    createClientNotificationModel(flows, firestore),
  );
  return $notifications;
}

export type $NotificationsContainer = ReturnType<typeof createNotificationsContainer>;
export type NotificationsContainer = $NotificationsContainer['use'];
